module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp3_5012.5faa6469.png";